<template>
  <CardWrapper class="card-1" :loading="!article">
    <div v-if="article" class="status-icon">
      <q-img v-if="article.oa_status !== null" :src="icon" spinner-color="white" />
      <QuestionMark v-else />
      <LmTooltip> {{ status }} </LmTooltip>
    </div>

    <strong>Open access status</strong>
  </CardWrapper>
</template>

<script>
import CardWrapper from '../CardWrapper'

export default {
  components: {
    CardWrapper,
    QuestionMark: () => import('@/reusable/svg-icons/QuestionMark')
  },

  props: {
    article: Object
  },

  computed: {
    status() {
      if (!this.article) return
      if (this.article.oa_status === true) return 'Open'
      else if (this.article.oa_status === false) return 'Closed'
      return 'Unknown'
    },

    icon() {
      if (!this.article) return
      if (this.article.oa_status === true) return require('@/assets/open-access-1.png')
      return require('@/assets/open-access-0.png')
    }
  }
}
</script>

<style lang="stylus" scoped>
.card-1 {
  text-align center

  >>> .status-icon {
    padding 20px
    > * {
      height 72px
      width 72px
    }
  }
}
</style>
